import React, { Component } from 'react'
import Included from '../Included'
class Nav extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return (
    <section>
      <a className="anchor" id="navigation"></a>
      <h2>Navigation</h2>
      <br/>

      <p>The top-level navigation is available in several variations. The default navigation bar should be used within your application for app-level navigation by applying a class of <code className="inline">nav</code> to any block-level container, e.g. <code className="inline">&lt;div&gt;</code>. The suggested container for your navigation, however, would be the HTML5 <a href="https://developer.mozilla.org/en/docs/Web/HTML/Element/nav" target="_blank">nav</a> element.</p>

      <p>The top-level navigation bar consists of 3 (optional) sections:</p>
      <ol className="push--left">
        <li>A "header" section, containing the CME Group logo. The header section can also contain an optional application/site name immediately adjacent to the logo.</li>
        <li>An "items" section, containing one or more navigation items. Each item can be either a string representing the top-level title of a block of secondary navigation items, or a link. Note that, at present, if secondary level items exist then the primary item must not be a link, as this will interfere with the mobile/responsive behavior. In this case the primary item should still be an anchor tag, but without an href attribute, e.g. <code className="inline">&lt;a&gt;Title&lt;/a&gt;</code></li>
        <li>An "actions" section, containing one or more action items. Each action item should ideally be represented by a <code className="inline">&lt;button&gt;</code> element with a class of <code className="inline">nav__action-btn</code>, and containing an <a href="#icons">icon</a>.</li>
      </ol>

      <div className="callout">
        <strong>Note:</strong> To display the logo as the CME Group globe only, add a class of <code className="inline">nav__logo--globe-only</code> to the <code className="inline">nav__logo</code> element.
      </div>

      <br/>

      <h3>Top-level Navigation</h3>

      <p>Top-level navigation styles are reserved for sites/applications that exist outside of Customer Center (a.k.a Uno or Common Nav). For example, cmegroup.com, CME Institute, CME One etc. Top-level navigation is denoted by the presence of the <code className="inline">nav--global</code> class. To change the theme to use the dark theme the <code className="inline">nav--dark</code> class should also be applied.</p>

      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
        <option value="1602">1600px (xlg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"275px"}}>
        <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>

              <nav class="nav nav--global nav--dark drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--logo-only">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary">
                      <a>Trading</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Agricultural</a></li>
                        <li class="nav__item--secondary"><a>Energy</a></li>
                        <li class="nav__item--secondary"><a>Equity Index</a></li>
                        <li class="nav__item--secondary"><a>FX</a></li>
                        <li class="nav__item--secondary"><a>Interest Rates</a></li>
                        <li class="nav__item--secondary"><a>Metals</a></li>
                        <li class="nav__item--secondary"><a>Options</a></li>
                        <li class="nav__item--secondary"><a>OTC</a></li>
                        <li class="nav__item--secondary"><a>Weather</a></li>
                        <li class="nav__item--secondary"><a>Real Estate</a></li>
                        <li class="nav__item--secondary"><a>Technology</a></li>
                        <li class="nav__item--secondary"><a>CME Globex</a></li>
                        <li class="nav__item--secondary"><a>CME Direct</a></li>
                        <li class="nav__item--secondary"><a>CME ClearPort</a></li>
                        <li class="nav__item--secondary"><a>Straight Through Processing (STP)</a></li>
                        <li class="nav__item--secondary"><a>Global Repository Services</a></li>
                        <li class="nav__item--secondary"><a>Co-Location Services</a></li>
                        <li class="nav__item--secondary"><a>CME Pivot</a></li>
                        <li class="nav__item--secondary"><a>Membership</a></li>
                        <li class="nav__item--secondary"><a>Fees</a></li>
                        <li class="nav__item--secondary"><a>Incentive Programs</a></li>
                        <li class="nav__item--secondary"><a>Tools &amp; Resources</a></li>
                        <li class="nav__item--secondary"><a>Swap Execution Facility (SEF)</a></li>
                        <li class="nav__item--secondary"><a>CME Europe</a></li>
                        <li class="nav__item--secondary"><a>Economic Research</a></li>
                        <li class="nav__item--secondary"><a>Holiday Calendar</a></li>
                        <li class="nav__item--secondary"><a>Find a Broker</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary is-active">
                      <a>Clearing</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Clearing Home</a></li>
                        <li class="nav__item--secondary is-active"><a>Risk Management</a></li>
                        <li class="nav__item--secondary"><a>Financial &amp; Collateral Management</a></li>
                        <li class="nav__item--secondary"><a>Financial and Regulatory Surveillance</a></li>
                        <li class="nav__item--secondary"><a>Clearing Operations and Deliveries</a></li>
                        <li class="nav__item--secondary"><a>Performance Bonds / Margins</a></li>
                        <li class="nav__item--secondary"><a>Clearing Advisories</a></li>
                        <li class="nav__item--secondary is-active"><a>CME Clearing Europe</a></li>
                        <li class="nav__item--secondary"><a>Margin Services</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Regulation</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Market Regulation Home</a></li>
                        <li class="nav__item--secondary"><a>Investigations</a></li>
                        <li class="nav__item--secondary"><a>Data Investigations</a></li>
                        <li class="nav__item--secondary"><a>Market Surveillance</a></li>
                        <li class="nav__item--secondary"><a>Enforcement</a></li>
                        <li class="nav__item--secondary"><a>Regulatory Outreach</a></li>
                        <li class="nav__item--secondary"><a>Advisory Notices</a></li>
                        <li class="nav__item--secondary"><a>Subscription Center</a></li>
                        <li class="nav__item--secondary"><a>Rulebooks</a></li>
                        <li class="nav__item--secondary"><a>Rule Filings</a></li>
                        <li class="nav__item--secondary"><a>Disciplinary Notices</a></li>
                        <li class="nav__item--secondary"><a>Arbitration</a></li>
                        <li class="nav__item--secondary"><a>Position Links</a></li>
                        <li class="nav__item--secondary"><a>Registrar's Advisories</a></li>
                        <li class="nav__item--secondary"><a>Market Regulation Advisory Notices</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Data</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Market Data Home</a></li>
                        <li class="nav__item--secondary"><a>Settlements</a></li>
                        <li class="nav__item--secondary"><a>Volume &amp; Open Interest</a></li>
                        <li class="nav__item--secondary"><a>Daily Bulletin</a></li>
                        <li class="nav__item--secondary"><a>Registrar Reports</a></li>
                        <li class="nav__item--secondary"><a>New &amp; Existing Distributors</a></li>
                        <li class="nav__item--secondary"><a>Licensed Distributor List</a></li>
                        <li class="nav__item--secondary"><a>Delayed Quotes</a></li>
                        <li class="nav__item--secondary"><a>Block Trades</a></li>
                        <li class="nav__item--secondary"><a>MDP (Streaming)</a></li>
                        <li class="nav__item--secondary"><a>E-Quotes</a></li>
                        <li class="nav__item--secondary"><a>Datamine (Historical)</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Education</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Education Home</a></li>
                        <li class="nav__item--secondary"><a>Learn About Trading</a></li>
                        <li class="nav__item--secondary"><a>Practice Trading</a></li>
                        <li class="nav__item--secondary"><a>Risk Management/Hedging</a></li>
                        <li class="nav__item--secondary"><a>Event Calendar</a></li>
                        <li class="nav__item--secondary"><a>Podcasts</a></li>
                        <li class="nav__item--secondary"><a>All Education Materials</a></li>
                        <li class="nav__item--secondary"><a>Alternative Investment Resources</a></li>
                        <li class="nav__item--secondary"><a>Latest Market Reports</a></li>
                        <li class="nav__item--secondary"><a>Futures Institute</a></li>
                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>About</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>About Us Home</a></li>
                        <li class="nav__item--secondary"><a>Corporate Overview</a></li>
                        <li class="nav__item--secondary"><a>Global Offices</a></li>
                        <li class="nav__item--secondary"><a>Center for Innovation</a></li>
                        <li class="nav__item--secondary"><a>Corporate Citizenship</a></li>
                        <li class="nav__item--secondary"><a>Careers</a></li>
                        <li class="nav__item--secondary"><a>Investor Relations</a></li>
                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>
                        <li class="nav__item--secondary"><a>Futures Institute</a></li>
                        <li class="nav__item--secondary"><a>Media Room</a></li>
                        <li class="nav__item--secondary"><a>News</a></li>
                        <li class="nav__item--secondary"><a>Jobs</a></li>
                        <li class="nav__item--secondary"><a>Open Markets</a></li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
                  </ul>
                </div>
              </nav>

              <br/>

              <nav class="nav nav--global nav--dark drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--alternate">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                    <h1 class="nav__app-name">CME Institute</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a>Learn</a></li>
                    <li class="nav__item--primary"><a>Practice</a></li>
                    <li class="nav__item--primary"><a>Challenge</a></li>
                    <li class="nav__item--primary"><a>Markets</a></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
                  </ul>
                </div>
              </nav>

              <br/>

              <nav class="nav nav--global nav--dark drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                    <h1 class="nav__app-name">Customer Center</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a>Portfolio &amp; Risk</a></li>
                    <li class="nav__item--primary"><a>Regulatory</a></li>
                    <li class="nav__item--primary"><a>Apps &amp; Analytics</a></li>
                    <li class="nav__item--primary"><a>Administration</a></li>
                    <li class="nav__item--primary"><a>Default</a></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="21"></i></button></li>
                  </ul>
                </div>
              </nav>

              <br/>

              <nav class="nav nav--global nav--blue drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--logo-only">
                    <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                  </div>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon"></i></button></li>
                  </ul>
                </div>
              </nav>

            </body>
            <script type="text/javascript" src="js/commonUI.js"></script>
            <script>
              function init() {
                commonUI.initializeNavigation();
              }
              window.onload = init;
            </script>
          </html>
        `}></iframe>
      </div>

      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<nav class="nav nav--global nav--dark drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--logo-only">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Trading</a></li>
      <li class="nav__item--primary"><a>Clearing</a></li>
      <li class="nav__item--primary"><a>Regulation</a></li>
      <li class="nav__item--primary"><a>Data</a></li>
      <li class="nav__item--primary"><a>Education</a></li>
      <li class="nav__item--primary"><a>About</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
    </ul>
  </div>
</nav>

<nav class="nav nav--global nav--dark drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--alternate">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      <h1 class="nav__app-name">CME Institute</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Learn</a></li>
      <li class="nav__item--primary"><a>Practice</a></li>
      <li class="nav__item--primary"><a>Challenge</a></li>
      <li class="nav__item--primary"><a>Markets</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
    </ul>
  </div>
</nav>

<nav class="nav nav--global nav--dark drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      <h1 class="nav__app-name">Customer Center</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Portfolio &amp; Risk</a></li>
      <li class="nav__item--primary"><a>Regulatory</a></li>
      <li class="nav__item--primary"><a>Apps &amp; Analytics</a></li>
      <li class="nav__item--primary"><a>Administration</a></li>
      <li class="nav__item--primary"><a>Default</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="21"></i></button></li>
    </ul>
  </div>
</nav>

<nav class="nav nav--global nav--blue drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--logo-only">
      <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
    </div>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon"></i></button></li>
    </ul>
  </div>
</nav>`}</code></pre>

      <div className="callout">
        <strong><i className="fa fa-lightbulb-o fa-lg"></i> Tip:</strong> To add a badge count to one of the action items add a custom data attribute called <code className="inline">data-badge-count</code> to the associated <code className="inline">nav__action-icon</code> element.
      </div>

      <br/>

      <h3>Light theme</h3>
      <p>In some scenarios, a lighter version of the navigation will be most appropriate. This version can be used for both internal and external apps, or as a basis for whitelabelling our nav component. It encompasses the same behaviour and interactions as the other versions, and has the option to add the logo and/or the stripes.</p>
      <p>The light theme can be implemented by adding the modifier class <code>.nav--light</code> to the navigation as shown in the example below. We have also added a modifier for the <code>.nav__header</code> to remove the strips either side of the logo, simply add the class <code>.nav__header--no-strips</code></p>


      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
        <option value="1602">1600px (xlg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"275px"}}>
        <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>

              <nav class="nav nav--global nav--light drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--logo-only">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary">
                      <a>Trading</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Agricultural</a></li>
                        <li class="nav__item--secondary"><a>Energy</a></li>
                        <li class="nav__item--secondary"><a>Equity Index</a></li>
                        <li class="nav__item--secondary"><a>FX</a></li>
                        <li class="nav__item--secondary"><a>Interest Rates</a></li>
                        <li class="nav__item--secondary"><a>Metals</a></li>
                        <li class="nav__item--secondary"><a>Options</a></li>
                        <li class="nav__item--secondary"><a>OTC</a></li>
                        <li class="nav__item--secondary"><a>Weather</a></li>
                        <li class="nav__item--secondary"><a>Real Estate</a></li>
                        <li class="nav__item--secondary"><a>Technology</a></li>
                        <li class="nav__item--secondary"><a>CME Globex</a></li>
                        <li class="nav__item--secondary"><a>CME Direct</a></li>
                        <li class="nav__item--secondary"><a>CME ClearPort</a></li>
                        <li class="nav__item--secondary"><a>Straight Through Processing (STP)</a></li>
                        <li class="nav__item--secondary"><a>Global Repository Services</a></li>
                        <li class="nav__item--secondary"><a>Co-Location Services</a></li>
                        <li class="nav__item--secondary"><a>CME Pivot</a></li>
                        <li class="nav__item--secondary"><a>Membership</a></li>
                        <li class="nav__item--secondary"><a>Fees</a></li>
                        <li class="nav__item--secondary"><a>Incentive Programs</a></li>
                        <li class="nav__item--secondary"><a>Tools &amp; Resources</a></li>
                        <li class="nav__item--secondary"><a>Swap Execution Facility (SEF)</a></li>
                        <li class="nav__item--secondary"><a>CME Europe</a></li>
                        <li class="nav__item--secondary"><a>Economic Research</a></li>
                        <li class="nav__item--secondary"><a>Holiday Calendar</a></li>
                        <li class="nav__item--secondary"><a>Find a Broker</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary is-active">
                      <a>Clearing</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Clearing Home</a></li>
                        <li class="nav__item--secondary is-active"><a>Risk Management</a></li>
                        <li class="nav__item--secondary"><a>Financial &amp; Collateral Management</a></li>
                        <li class="nav__item--secondary"><a>Financial and Regulatory Surveillance</a></li>
                        <li class="nav__item--secondary"><a>Clearing Operations and Deliveries</a></li>
                        <li class="nav__item--secondary"><a>Performance Bonds / Margins</a></li>
                        <li class="nav__item--secondary"><a>Clearing Advisories</a></li>
                        <li class="nav__item--secondary"><a>CME Clearing Europe</a></li>
                        <li class="nav__item--secondary"><a>Margin Services</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Regulation</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Market Regulation Home</a></li>
                        <li class="nav__item--secondary"><a>Investigations</a></li>
                        <li class="nav__item--secondary"><a>Data Investigations</a></li>
                        <li class="nav__item--secondary"><a>Market Surveillance</a></li>
                        <li class="nav__item--secondary"><a>Enforcement</a></li>
                        <li class="nav__item--secondary"><a>Regulatory Outreach</a></li>
                        <li class="nav__item--secondary"><a>Advisory Notices</a></li>
                        <li class="nav__item--secondary"><a>Subscription Center</a></li>
                        <li class="nav__item--secondary"><a>Rulebooks</a></li>
                        <li class="nav__item--secondary"><a>Rule Filings</a></li>
                        <li class="nav__item--secondary"><a>Disciplinary Notices</a></li>
                        <li class="nav__item--secondary"><a>Arbitration</a></li>
                        <li class="nav__item--secondary"><a>Position Links</a></li>
                        <li class="nav__item--secondary"><a>Registrar's Advisories</a></li>
                        <li class="nav__item--secondary"><a>Market Regulation Advisory Notices</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Data</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Market Data Home</a></li>
                        <li class="nav__item--secondary"><a>Settlements</a></li>
                        <li class="nav__item--secondary"><a>Volume &amp; Open Interest</a></li>
                        <li class="nav__item--secondary"><a>Daily Bulletin</a></li>
                        <li class="nav__item--secondary"><a>Registrar Reports</a></li>
                        <li class="nav__item--secondary"><a>New &amp; Existing Distributors</a></li>
                        <li class="nav__item--secondary"><a>Licensed Distributor List</a></li>
                        <li class="nav__item--secondary"><a>Delayed Quotes</a></li>
                        <li class="nav__item--secondary"><a>Block Trades</a></li>
                        <li class="nav__item--secondary"><a>MDP (Streaming)</a></li>
                        <li class="nav__item--secondary"><a>E-Quotes</a></li>
                        <li class="nav__item--secondary"><a>Datamine (Historical)</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>Education</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>Education Home</a></li>
                        <li class="nav__item--secondary"><a>Learn About Trading</a></li>
                        <li class="nav__item--secondary"><a>Practice Trading</a></li>
                        <li class="nav__item--secondary"><a>Risk Management/Hedging</a></li>
                        <li class="nav__item--secondary"><a>Event Calendar</a></li>
                        <li class="nav__item--secondary"><a>Podcasts</a></li>
                        <li class="nav__item--secondary"><a>All Education Materials</a></li>
                        <li class="nav__item--secondary"><a>Alternative Investment Resources</a></li>
                        <li class="nav__item--secondary"><a>Latest Market Reports</a></li>
                        <li class="nav__item--secondary"><a>Futures Institute</a></li>
                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>
                      </ul>
                    </li>
                    <li class="nav__item--primary">
                      <a>About</a>
                      <ul class="nav__items--secondary">
                        <li class="nav__item--secondary"><a>About Us Home</a></li>
                        <li class="nav__item--secondary"><a>Corporate Overview</a></li>
                        <li class="nav__item--secondary"><a>Global Offices</a></li>
                        <li class="nav__item--secondary"><a>Center for Innovation</a></li>
                        <li class="nav__item--secondary"><a>Corporate Citizenship</a></li>
                        <li class="nav__item--secondary"><a>Careers</a></li>
                        <li class="nav__item--secondary"><a>Investor Relations</a></li>
                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>
                        <li class="nav__item--secondary"><a>Futures Institute</a></li>
                        <li class="nav__item--secondary"><a>Media Room</a></li>
                        <li class="nav__item--secondary"><a>News</a></li>
                        <li class="nav__item--secondary"><a>Jobs</a></li>
                        <li class="nav__item--secondary"><a>Open Markets</a></li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
                  </ul>
                </div>
              </nav>

              <br/>

              <nav class="nav nav--light nav--global drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--no-strips">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                    <h1 class="nav__app-name">CME Institute</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a>Learn</a></li>
                    <li class="nav__item--primary"><a>Practice</a></li>
                    <li class="nav__item--primary"><a>Challenge</a></li>
                    <li class="nav__item--primary"><a>Markets</a></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
                  </ul>
                </div>
              </nav>



            </body>
            <script type="text/javascript" src="js/commonUI.js"></script>
            <script>
              function init() {
                commonUI.initializeNavigation();
              }
              window.onload = init;
            </script>
          </html>
        `}></iframe>
      </div>

      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<nav class="nav nav--global nav--light drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--logo-only">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Trading</a></li>
      <li class="nav__item--primary"><a>Clearing</a></li>
      <li class="nav__item--primary"><a>Regulation</a></li>
      <li class="nav__item--primary"><a>Data</a></li>
      <li class="nav__item--primary"><a>Education</a></li>
      <li class="nav__item--primary"><a>About</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
    </ul>
  </div>
</nav>

<nav class="nav nav--light nav--global drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--no-strips">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      <h1 class="nav__app-name">CME Institute</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Learn</a></li>
      <li class="nav__item--primary"><a>Practice</a></li>
      <li class="nav__item--primary"><a>Challenge</a></li>
      <li class="nav__item--primary"><a>Markets</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
    </ul>
  </div>
</nav>`}</code></pre>

      <br/>

      <h4>"Active" State</h4>

      <p>To denote the "active" navigation item at either the primary or secondary level, apply a class of <code className="inline">is-active</code> to the appropriate navigation item. Note that if a secondary level item is currently active, then the <code className="inline">is-active</code> class should be applied to both the secondary level item <em>and</em> its corresponding primary level item, as demonstrated in the examples both above and below.</p>

      <h3>Default/App-level Navigation</h3>

      <p>The default app-level navigation should be used for apps that reside within Uno/Common Nav.</p>

      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
        <option value="1602">1600px (xlg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"250px"}}>
        <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>
              <nav class="nav drop-shadow js-nav responsive-nav-example">
                <div class="nav__inner">
                  <div class="nav__header">
                    <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                    <h1 class="nav__app-name">Request Center</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a onclick="handleClick(this)">My Requests</a></li>
                    <li class="nav__item--primary is-active"><a onclick="handleClick(this)">Globex Requests</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Globex Firms</a></li><li class="nav__item--secondary is-active"><a onclick="handleClick(this)">Drop Copy Groups</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">iLink Sessions</a></li></ul></li>
                    <li class="nav__item--primary"><a onclick="handleClick(this)">OTC</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Exchange Registration</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Funds</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Platform</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Counterparty</a></li></ul></li>
                    <li class="nav__item--primary"><a onclick="handleClick(this)">Incentive Programs</a></li>
                    <li class="nav__item--primary"><a onclick="handleClick(this)">Preferences</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Clearing Firms</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Front End Systems</a></li></ul></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn" id="contact-us-tool-tip"><i class="fa fa-phone"></i></button></li>
                    <li class="nav__action"><a class="nav__action-link" href="http://www.cmegroup.com/tools-information/webhelp/cme-customer-center/Default.html" target="_blank" title="Help"><i class="fa fa-question-circle"></i></a></li>
                </div>
              </nav>
            </body>
            <script type="text/javascript" src="js/commonUI.js"></script>
            <script>
              function init() {
                responsiveNav = commonUI.initializeNavigation({
                  selector: '.responsive-nav-example',
                });
              }
              const handleClick = (e) => {
                const selectedNavItem = e.closest('li');
                const activeNavItems = responsiveNav.nav.querySelectorAll('.is-active');

                activeNavItems.forEach((elem) => elem.classList.remove('is-active'));
                selectedNavItem.classList.add('is-active');

                if (selectedNavItem.classList.contains('nav__item--secondary')) {
                  selectedNavItem.closest('.nav__item--primary.has-children').classList.add('is-active');
                }
              }
              window.onload = init;
            </script>
          </html>
        `}></iframe>
      </div>

      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<nav class="nav drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header">
      <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      <h1 class="nav__app-name">Request Center</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>My Requests</a></li>
      <li class="nav__item--primary is-active">
        <a>Globex Requests</a>
        <ul class="nav__items--secondary">
          <li class="nav__item--secondary"><a>Globex Firms</a></li>
          <li class="nav__item--secondary is-active"><a>Drop Copy Groups</a></li>
          <li class="nav__item--secondary"><a>iLink Sessions</a></li>
        </ul>
      </li>
      <li class="nav__item--primary">
        <a>OTC</a>
        <ul class="nav__items--secondary">
          <li class="nav__item--secondary"><a>Exchange Registration</a></li>
          <li class="nav__item--secondary"><a>Funds</a></li>
          <li class="nav__item--secondary"><a>Platform</a></li>
          <li class="nav__item--secondary"><a>Counterparty</a></li>
        </ul>
      </li>
      <li class="nav__item--primary">
        <a>Incentive Programs</a>
      </li>
      <li class="nav__item--primary">
        <a>Preferences</a>
        <ul class="nav__items--secondary">
          <li class="nav__item--secondary"><a>Clearing Firms</a></li>
          <li class="nav__item--secondary"><a>Front End Systems</a></li>
        </ul>
      </li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn" id="contact-us-tool-tip"><i class="fa fa-phone"></i></button></li>
      <li class="nav__action"><a class="nav__action-link" href="http://www.cmegroup.com/tools-information/webhelp/cme-customer-center/Default.html" target="_blank" title="Help"><i class="fa fa-question-circle"></i></a></li>
    </ul>
  </div>
</nav>`}</code></pre>

      <br/>

      <h3>Responsive Navigation</h3>

      <p>This is a partly JavaScript enabled component &mdash; by default, the navigation will work without JavaScript. However, should you need to implement mobile/responsive navigation functionality within your site or application, then you must include the commonUI JavaScript library on the page and apply a class of <code className="inline">js-nav</code> to act as a JavaScript hook on the top-level navigation element.</p>

      <p>To initialize the navigation using the default selector <code className="inline">js-nav</code>, call the following once the page has fully rendered:</p>

      <pre><code className="language-js">{`commonUI.initializeNavigation();`}</code></pre>

      <p>If you wish to use a JS hook other than <code className="inline">js-nav</code> you can also initialize the navigation in the following manner:</p>

      <pre><code className="language-js">{`commonUI.initializeNavigation({selector: ".js-main-nav"});`}</code></pre>

      <br/>
      <hr/>

    </section>
    )
  }

//  render (){
//    return(
//    <section>
//      <a className="anchor" id="nav"></a>
//      <h2>Navigation</h2>
//      <br/>
//      <p>Classic theme</p>
//      <ul className="nav nav--branded-classic">
//        <li><a href="#">Trading</a></li>
//        <li><a href="#">Clearing</a></li>
//        <li><a href="#" className="nav--selected">Regulation</a></li>
//        <li><a href="#">Data</a></li>
//      </ul>
//
//      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
//      <pre className="hide-code"><code className="language-html">{`<ul class="nav nav--branded-classic">
//  <li><a href="#">Trading</a></li>
//  <li><a href="#">Clearing</a></li>
//  <li><a href="#" class="nav--selected">Regulation</a></li>
//  <li><a href="#">Data</a></li>
//</ul>`}</code></pre>
//
//      <br/>
//      <p>Main navigation theme</p>
//      <ul className="nav nav--branded-main">
//        <li><a href="#">Trading</a></li>
//        <li><a href="#">Clearing</a></li>
//        <li><a href="#" className="nav--selected">Regulation</a></li>
//        <li><a href="#">Data</a></li>
//      </ul>
//
//      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
//      <pre className="hide-code"><code className="language-html">{`<ul class="nav nav--branded-main">
//  <li><a href="#">Trading</a></li>
//  <li><a href="#">Clearing</a></li>
//  <li><a href="#" class="nav--selected">Regulation</a></li>
//  <li><a href="#">Data</a></li>
//</ul>`}</code></pre>
//
//      <br/>
//      <p>Multi level</p>
//      <div className="js-nav">
//        <ul className="nav nav--branded-main">
//          <li><a href="#">About</a></li>
//          <li><a href="#">Services</a></li>
//          <li>
//            <a className="nav__submenu" href="#">Offices &#9660;</a>
//            <ul className="nav nav--branded-main">
//              <li><a href="#">Chicago</a></li>
//              <li><a href="#">London</a></li>
//              <li><a href="#">Belfast</a></li>
//              <li><a href="#">Singapore</a></li>
//            </ul>
//          </li>
//        </ul>
//      </div>
//
//      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
//      <pre className="hide-code"><code className="language-html">{`<div class="js-nav">
//  <ul class="nav nav--branded-main js-nav">
//    <li><a href="#">About</a></li>
//    <li><a href="#">Services</a></li>
//    <li>
//        <a class="nav__submenu" href="#">Offices &#9660;</a>
//        <ul class="nav nav--branded-main">
//            <li><a href="#">Chicago</a></li>
//            <li><a href="#">London</a></li>
//            <li><a href="#">Belfast</a></li>
//            <li><a href="#">Singapore</a></li>
//        </ul>
//    </li>
//    <li><a href="#">Contact</a></li>
//  </ul>
//</div>`}</code></pre>
//
//      <br/>
//      <p>Responsive multi level</p>
//        <select className="size-select">
//          <option value="">Select a resolution</option>
//          <option value="482">480px (xs)</option>
//          <option value="770">768px (sm)</option>
//          <option value="994">992px (md)</option>
//          <option value="1202">1200px (lg)</option>
//        </select>
//        <br/><br/>
//        <div className="iframe-container" style={{"height":"400px"}}>
//          <iframe seamless srcDoc={`
//          <html>
//            <head>
//              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
//              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
//              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
//            </head>
//            <body>
//            <div class="js-nav">
//              <ul class="nav nav--branded-main">
//                <li class="js-nav-toggle visuallyhidden--lap-and-up"><a><span><i class="fa fa-bars"></i>Menu</span></a></li>
//              </ul>
//              <ul class="nav nav--branded-main nav--collapse">
//                <li><a href="#">About</a></li>
//                <li><a href="#">Services</a></li>
//                <li>
//                  <a class="nav__submenu" href="#">Offices &#9660;</a>
//                  <ul class="nav nav--branded-main">
//                    <li><a href="#">Chicago</a></li>
//                    <li><a href="#">London</a></li>
//                    <li><a href="#">Belfast</a></li>
//                    <li><a href="#">Singapore</a></li>
//                  </ul>
//                </li>
//                <li><a href="#">Contact</a></li>
//              </ul>
//            </div>
//          </body>
//          <script type="text/javascript" src="js/commonUI.js"></script>
//          <script>
//            function init() {
//              commonUI.initializeNavigation();
//            }
//            window.onload = init;
//          </script>
//        </html>`}>
//          </iframe>
//        </div>
//
//      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
//      <pre className="hide-code"><code className="language-html">{`<div class="js-nav">
//	<ul class="nav nav--branded-main">
//		<li class="js-nav-toggle visuallyhidden--lap-and-up"><a><span><i class="fa fa-bars"></i>Menu</span></a></li>
//	</ul>
//  <ul class="nav nav--branded-main nav--collapse">
//    <li><a href="#">About</a></li>
//    <li><a href="#">Services</a></li>
//    <li>
//        <a class="nav__submenu" href="#">Offices &#9660;</a>
//        <ul class="nav nav--branded-main">
//            <li><a href="#">Chicago</a></li>
//            <li><a href="#">London</a></li>
//            <li><a href="#">Belfast</a></li>
//            <li><a href="#">Singapore</a></li>
//        </ul>
//    </li>
//    <li><a href="#">Contact</a></li>
//  </ul>
//</div>`}</code></pre>
//
//      <br/>
//      <p>An example of this in use can be found in this <a href="samples/tables.html">sample layout.</a></p>
//        <br/>
//
//        <p>This is a partly javascript enabled component. You need to use the classes shown above to enable the responsive menu</p>
//        <p><b>Responsive functionality is only available with javascript</b></p>
//
//        <pre><code className="language-javascript">{`// Using default classes shown in snippet.
//// The library looks for the class 'js-nav' and 'js-nav-toggle' by default.
//commonUI.initializeNavigation();
//
//// You can have multiple navs on the page, they will all be initialised
//
//// Using custom selectors
//commonUI.initializeNavigation(
//  {
//    selector: '.special-nav',
//    clickElementSelector: '.special-nav-toggle-button'
//  }
//);`}</code></pre>
//
//    <br/>
//    <hr />
//    </section>
//  )
//}
}

export default Nav



// WEBPACK FOOTER //
// ./styleguide/components/sections/Nav.js